<template>
    <div
    >

        <kgr-form-scaffold
            v-if="config.subTitles"
            :with-back-button="false"
            :pending="loading"
            @primaryBtnClicked="saveConfig"
        >
            <h3
                class="kgr-headline kgr-headline--h3 kgr-headline--text"
                v-t="'Untertitel der E-Signaturen'"
            ></h3>
            <kgr-note-box
                text-key="kindergarten.eSignature.config.note"
            />
            <br />
            <div
                v-for="(item,index) in config.subTitles" :key="index"
                class="kgr-postfix"
                style="border-top:1px solid #efefef;width:100%"
            >
                <div class="kgr-postfix__fluid" style="vertical-align: bottom;width:60%">
                    <br />
                    <kgr-input-group

                        :label="getLabel(item.name)"
                        :error-message="error.messageForField(getErrorPath(item.name))"
                    >
                        <input
                            v-model.trim="item.value"
                            :placeholder="item.default"
                            type="text"
                            maxlength="50"
                            class="kgr-input"
                        />
                    </kgr-input-group>
                </div>
                <div class="kgr-postfix__fluid" style="padding: 20px 0;width:40%">
                    <div style="width: 100%;margin:0 20px">
                        <div style="width: 203pt;">
                            <div style="border-bottom:1px solid black;height:90pt;background-color: #fbf9b5;">
                                <span style="color:white"></span>
                            </div>
                            <div style="font-size:9pt;">{{ item.value === null || item.value === '' ? item.default : item.value }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </kgr-form-scaffold>
    </div>
</template>

<script>
import Error from '../../../js/model/Error.js';
import FormScaffold from '../../common/form/FormScaffold.vue';
import InputGroup from '../../common/form/InputGroup.vue';
import NoteBox from '../../common/NoteBox.vue';
import axios from 'axios';

export default {
    components: {
        'kgr-note-box': NoteBox,
        'kgr-input-group': InputGroup,
        'kgr-form-scaffold': FormScaffold,
    },
    props: {
        kindergartenId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            error: new Error(),
            config: [],
            loading: true
        }
    },
    mounted() {
        this.loadConfig();
    },
    methods: {
        getErrorPath(subTitleIdentifier) {
            switch(subTitleIdentifier) {
                case 'employee':
                    return 'subTitleEmployee';
                case 'firstCustody':
                    return 'subTitleFirstCustody';
                case 'firstCustodyOptional':
                    return 'subTitleFirstCustodyOptional';
                case 'secondCustody':
                    return 'subTitleSecondCustody';
                case 'secondCustodyOptional':
                    return 'subTitleSecondCustodyOptional';
                default:
                    console.error('Unknown subtitle identifier: ' + subTitleIdentifier);
            }
        },
        loadConfig() {
            axios.get(`/kindergartens/${this.kindergartenId}/signable-letters-config`)
                .then(response => {
                    this.config = response.data.data;
                })
                .catch(error => {
                    console.error('There was an error!', error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getLabel(subTitleIdentifier) {
            switch(subTitleIdentifier) {
                case 'employee':
                    return this.$t('Untertitel der E-Signatur für Mitarbeiter');
                case 'firstCustody':
                    return this.$t('Untertitel der E-Signatur für Sorgeberechtigte/n (Pflicht)');
                case 'firstCustodyOptional':
                    return this.$t('Untertitel der E-Signatur für Sorgeberechtigte/n (optional)');
                case 'secondCustody':
                    return this.$t('Untertitel der E-Signatur für weitere/n Sorgeberechtigte/n (Pflicht)');
                case 'secondCustodyOptional':
                    return this.$t('Untertitel der E-Signatur für weitere/n Sorgeberechtigte/n (optional)');
                default:
                    return subTitleIdentifier;
            }
        },
        saveConfig() {
            this.loading = true;
            this.error = new Error();
            const subTitleEmployee = this.config.subTitles.find(s => s.name === 'employee').value;
            const subTitleFirstCustody = this.config.subTitles.find(s => s.name === 'firstCustody').value;
            const subTitleFirstCustodyOptional = this.config.subTitles.find(s => s.name === 'firstCustodyOptional').value;
            const subTitleSecondCustody = this.config.subTitles.find(s => s.name === 'secondCustody').value;
            const subTitleSecondCustodyOptional = this.config.subTitles.find(s => s.name === 'secondCustodyOptional').value;
            axios.put(`/signable-letters-config/${this.config.id}`, {
                subTitleEmployee: subTitleEmployee === '' ? null : subTitleEmployee,
                subTitleFirstCustody: subTitleFirstCustody === '' ? null : subTitleFirstCustody,
                subTitleFirstCustodyOptional: subTitleFirstCustodyOptional === '' ? null : subTitleFirstCustodyOptional,
                subTitleSecondCustody: subTitleSecondCustody === '' ? null : subTitleSecondCustody,
                subTitleSecondCustodyOptional: subTitleSecondCustodyOptional === '' ? null : subTitleSecondCustodyOptional,
            })
                .then(() => {
                    this.$notify.success('saveChanges.success')
                })
                .then(() => {
                    return this.loadConfig();
                })
                .catch(error => {
                    this.$notify.error('saveChanges.error')
                    this.error = Error.fromResponse(error.response)
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>

</style>
